// extracted by mini-css-extract-plugin
export default {"list":"BusinessList_list__FsQtz"};